<script setup lang="ts">
import {
  ArrowPathIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  InformationCircleIcon,
} from "@heroicons/vue/20/solid";
import { DateTime } from "luxon";
import { computed, onMounted, ref, watch } from "vue";
import StatsIcon from "../assets/images/stats.png";
import CustomSelect from "../components/Common/CustomSelect.vue";
import { useLoading } from "../composables/useLoading";
import { useNotification } from "../composables/useNotification";
import { FirestoreService } from "../services/firestore";
const { setText, toggleLoading } = useLoading();
const { setError } = useNotification();
const currentYear = ref(DateTime.now().toFormat("yyyy"));
const currentMonth = ref(DateTime.now().toFormat("MM"));
const selectedDay = ref(DateTime.now().toFormat("dd"));
const currentYearMonth = computed(
  () => `${currentYear.value}-${currentMonth.value}`,
);
const currentYearMonthDay = computed(
  () => `${currentYear.value}-${currentMonth.value}-${selectedDay.value}`,
);
const years = ref<string[]>([]);
const months = ref<string[]>([]);

const profitReport = ref<any>();

const getProfitReport = async () => {
  const path = `/profit-reports/XYl31k4LQENV8mrqCJPLqLxEESs1/reports/months/${currentYearMonth.value}`;
  console.log({ path });
  const result = await FirestoreService.getCollection<any>(path);
  console.log({ result });
  if (result) {
    profitReport.value = result;
  } else {
    profitReport.value = null;
  }
};
const refresh = async () => {
  setText("Loading report...");
  toggleLoading(true);
  try {
    await getProfitReport();
    // paymentSummaries.value =
    //   await FirestoreService.getCollection<PaymentSummary>(path);
  } catch (e) {
    setError("failed to load payments please try again");
  } finally {
    toggleLoading(false);
  }
};
watch(
  [currentYearMonthDay],
  async () => {
    await refresh();
  },
  { immediate: true },
);
const days = ["01", "02", "03", "04", "05", "06", "07", "08", "09"];
for (let i = 10; i <= 31; i++) {
  days.push(i.toString());
}
onMounted(() => {
  years.value = Array.from({ length: 5 }, (_, i) =>
    DateTime.now().minus({ years: i }).toFormat("yyyy"),
  );
  months.value = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
});
const nextMonth = () => {
  const current = DateTime.fromFormat(currentYearMonth.value, "yyyy-MM").plus({
    months: 1,
  });
  currentYear.value = current.toFormat("yyyy");
  currentMonth.value = current.toFormat("MM");
};

const previousMonth = () => {
  const current = DateTime.fromFormat(currentYearMonth.value, "yyyy-MM").minus({
    months: 1,
  });
  currentYear.value = current.toFormat("yyyy");
  currentMonth.value = current.toFormat("MM");
};

// const refunds = computed(() =>
//   paymentSummaries.value.reduce(
//     (acc, summary) => acc + (PaymentSummary.refund(summary) ?? 0),
//     0
//   )
// );
const totalProfit = computed(() => {
  if (!profitReport.value) return 0;
  return profitReport.value.reduce(
    (acc: number, payment: any) => acc + (payment.totalProfit.amount ?? 0),
    0,
  );
});
const processingProfit = computed(() => {
  if (!profitReport.value) return 0;
  return profitReport.value.reduce(
    (acc: number, payment: any) => acc + (payment.processingProfit.amount ?? 0),
    0,
  );
});
const payoutProfit = computed(() => {
  if (!profitReport.value) return 0;
  return profitReport.value.reduce(
    (acc: number, payment: any) => acc + (payment.payoutProfit.amount ?? 0),
    0,
  );
});
const total = computed(() => {
  if (!profitReport.value) return 0;
  return profitReport.value.reduce(
    (acc: number, payment: any) => acc + (payment.total.amount ?? 0),
    0,
  );
});
const stats = computed(() => [
  {
    id: 1,
    name: "Total Payments Processed",
    stat: (total.value / 100).toLocaleString("en-AU", {
      style: "currency",
      currency: "AUD",
    }),
    stat1: "AUD",
    change: "3%",
    changeType: "increase",
    // action: viewTodayPayments,
  },
  {
    id: 1,
    name: "Processing Profit",
    stat: processingProfit.value / 100 + "U",
    stat1: "AUD",
    change: "3%",
    changeType: "increase",
    // action: viewTodayPayments,
  },
  {
    id: 2,
    name: "Payout Profit",
    stat: payoutProfit.value / 100 + "U",
    stat1: "AUD",
    change: "3%",
    changeType: "increase",
    // action: viewTodayPayments,
  },
  {
    id: 3,
    name: "Total Profit",
    stat: totalProfit.value / 100 + "U",
    stat1: "AUD",
    change: "3%",
    changeType: "increase",
    // action: viewTodayPayments,
  },
]);
const monthMapping = {
  January: "01",
  February: "02",
  March: "03",
  April: "04",
  May: "05",
  June: "06",
  July: "07",
  August: "08",
  September: "09",
  October: "10",
  November: "11",
  December: "12",
};
const selectedMonth = ref<keyof typeof monthMapping>(
  DateTime.now().toFormat("LLLL") as keyof typeof monthMapping,
);
watch(selectedMonth, (selectedMonth) => {
  currentMonth.value = monthMapping[selectedMonth];
});
</script>
<template>
  <div class="flex flex-row justify-center items-center h-screen">
    <h1>Access Denied</h1>
  </div>
  <div class="px-6 pb-8 hidden">
    <div class="mb-6">
      <dl class="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-1 lg:grid-cols-4">
        <div
          v-for="item in stats"
          :key="item.id"
          class="relative overflow-hidden rounded-lg bg-white p-6 shadow"
        >
          <div>
            <img :src="StatsIcon" class="w-[56px]" />
          </div>

          <!-- <p
            :class="[
              item.changeType === 'increase'
                ? 'text-green-600'
                : 'text-red-600',
              'ml-2 flex items-baseline text-sm font-semibold',
            ]"
          >
            <ArrowUpIcon
              v-if="item.changeType === 'increase'"
              class="h-5 w-5 flex-shrink-0 self-center text-green-500"
              aria-hidden="true"
            />
            <ArrowDownIcon
              v-else
              class="h-5 w-5 flex-shrink-0 self-center text-red-500"
              aria-hidden="true"
            />
            <span class="sr-only">
              {{ item.changeType === "increase" ? "Increased" : "Decreased" }}
              by
            </span>
            {{ item.change }}
          </p> -->
          <div class="flex flex-row justify-start items-center space-x-2 mt-4">
            <p class="text-3xl font-medium font-poppins text-[#111827]">
              {{ item.stat }}
            </p>

            <!-- <tag
              :label="item.tag"
              color="green"
              v-if="item.tag && item.tagCondition && item.tagCondition()"
            /> -->
          </div>

          <!-- <div
            class="flex flex-row justify-start items-center space-x-2 mt-4"
            v-if="item.stat1"
          >
            <p class="text-xl font-medium font-poppins text-[#111827]">
              {{ item.stat1 }}
            </p>
          </div> -->
          <div class="flex flex-row justify-between mt-4">
            <div>
              <p class="font-medium font-poppins text-base text-[#111827]">
                {{ item.name }}
              </p>
            </div>
            <!-- <div class="text-sm" v-if="item.action">
              <a
                @click.prevent="item.action"
                href=""
                class="text-primary underline font-medium text-base font-poppins cursor-pointer"
                >View payments<span class="sr-only">
                  {{ item.name }} stats</span
                ></a
              >
            </div> -->
          </div>
          <div
            class="flex flex-row justify-start items-center mt-1"
            v-if="item.name === 'Refunds'"
          >
            <InformationCircleIcon class="w-5 h-5 text-gray-400" />
            <p class="text-gray-400 text-xs">
              Historical refunds may not be included
            </p>
          </div>
        </div>
      </dl>
    </div>
    <div class="sm:flex sm:items-center mb-6">
      <div
        class="sm:flex-auto flex flex-row justify-start space-x-2 items-center"
      >
        <h1 class="text-[#111827] font-poppins font-semibold text-2xl">
          Profits
        </h1>
        <arrow-path-icon
          class="w-6 h-6 text-black block cursor-pointer"
          @click="refresh"
        />
      </div>
    </div>
    <div class="flex flex-row justify-between items-center mb-6">
      <ChevronLeftIcon
        class="h-16 w-16 text-black cursor-pointer"
        aria-hidden="true"
        @click="previousMonth"
      />
      <div class="text-xl flex flex-row justify-start items-center space-x-2">
        <custom-select
          v-model="currentYear"
          :options="years"
          class="w-[150px]"
        />
        <div class="h-[20px]"><p>-</p></div>
        <custom-select
          v-model="selectedMonth"
          :options="months"
          class="w-[150px]"
        />
      </div>
      <ChevronRightIcon
        class="h-16 w-16 text-black cursor-pointer"
        aria-hidden="true"
        @click="nextMonth"
      />
    </div>
    <div
      class="flex flex-col justify-start items-center"
      v-if="!profitReport || profitReport.length === 0"
    >
      <h1
        class="font-poppins text-xl font-semibold leading-6 text-gray-900 mt-6"
      >
        No profit for the period selected.
      </h1>
    </div>
    <div v-else class="p-4 bg-white rounded-[16px]">
      <div class="-mx-4 mt-4 sm:-mx-0">
        <table class="min-w-full">
          <thead class="border-none">
            <tr class="border-none">
              <th
                scope="col"
                class="rounded-l-[16px] hidden sm:table-cell table-header font-poppins text-[12px] font-medium text-[#687588]"
              >
                Date
              </th>
              <th
                scope="col"
                class="rounded-l-[16px] hidden sm:table-cell table-header font-poppins text-[12px] font-medium text-[#687588]"
              >
                Prcoessing Profit
              </th>
              <th
                scope="col"
                class="rounded-l-[16px] hidden sm:table-cell table-header font-poppins text-[12px] font-medium text-[#687588]"
              >
                Payout Profit
              </th>
              <th
                scope="col"
                class="rounded-l-[16px] hidden sm:table-cell table-header font-poppins text-[12px] font-medium text-[#687588]"
              >
                Total Profit
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 bg-white">
            <tr v-for="payment in profitReport" :key="payment.site">
              <td
                class="w-full max-w-0 py-4 text-sm font-medium text-gray-900 sm:w-auto sm:max-w-none sm:pl-0"
              >
                {{ payment.date }}
                <dl class="font-normal lg:hidden">
                  <dt class="sr-only">Processing Profit</dt>
                  <dd class="mt-1 truncate text-gray-700">
                    Processing Profit:{{
                      (payment.processingProfit.amount ?? 0) / 100 + "U"
                    }}
                  </dd>
                  <dt class="sr-only">Payout Profit</dt>
                  <dd class="mt-1 truncate text-gray-700">
                    Payout Profit:{{
                      (payment.payoutProfit.amount ?? 0) / 100 + "U"
                    }}
                  </dd>
                  <dt class="sr-only">Total Profit</dt>
                  <dd class="mt-1 truncate text-gray-700">
                    Total Profit:{{
                      (payment.totalProfit.amount ?? 0) / 100 + "U"
                    }}
                  </dd>
                </dl>
              </td>
              <td class="hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">
                {{ (payment.processingProfit.amount ?? 0) / 100 + "U" }}
              </td>

              <td class="hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">
                {{ (payment.payoutProfit.amount ?? 0) / 100 + "U" }}
              </td>
              <td class="hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">
                {{ (payment.totalProfit.amount ?? 0) / 100 + "U" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
